import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'
import uniq from 'lodash.uniq'

import { ReactComponent as ArrowIcon } from 'shared/img/AAABBB/arrowTop2.svg'

import { BonusName, IUserPromotion } from 'shared/models/Promotion'
import { useMediaMaxTablet } from 'shared/style/var'

import { getPureGameId } from 'modules/SlotsRoot/providersData/GameCatalog/uniqGameId'

import { selectLocaleDict } from 'features/locale/selectors'
import { selectGameList, selectWagerSlots } from 'features/slots/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

import Button from 'components/UIKit/Button/Button'

import { getBonusInfo } from '../__data/index'
import { CardHeader } from './CardHeader'

import './Card.scss'

type IBackCardProps = {
  promotion: IUserPromotion
  onInfoClick: () => void
}

const b = block('bonus-card')

export const BackCard: React.FC<IBackCardProps> = ({ promotion, onInfoClick }) => {
  const { bonuses: locale, betHistory: localeB } = useSelector(selectLocaleDict, shallowEqual)

  const lang = useSelector(selectLanguage, shallowEqual)
  const gameList = useSelector(selectGameList, shallowEqual)
  const wageringGames = useSelector(selectWagerSlots, shallowEqual)
  const isMobile = useMediaMaxTablet()

  const isFreeSpinsBonusPromotion = useMemo(
    () =>
      BonusName.everyDepositFreeSpins === promotion.name ||
      BonusName.firstDepositFreeSpins === promotion.name ||
      BonusName.register === promotion.name,
    [promotion],
  )

  // const arrayForWagerProviders = useMemo(
  //   () =>
  //     uniq(
  //       gameList
  //         .filter(slot => wageringGames.includes(getPureGameId(slot.gameId)))
  //         .map(a => a.provider.charAt(0).toUpperCase() + a.provider.slice(1)),
  //     ).join(', '),
  //   [wageringGames, gameList],
  // )

  const arrayForFreeSpinsProviders = useMemo(
    () =>
      uniq(
        gameList.filter(slot => slot.hasFreeSpins).map(a => a.provider.charAt(0).toUpperCase() + a.provider.slice(1)),
      ).join(', '),
    [gameList],
  )

  const { back: infoByBonusName, img: bonusIcon } = useMemo(
    () => getBonusInfo({ promotion, isMobile, locale }),
    [locale, isMobile, promotion],
  )

  return (
    <div className={b({ back: true })}>
      <CardHeader promotion={promotion} logoIcon={bonusIcon[lang]} onInfoClick={onInfoClick} />

      <div className={b('content')}>
        {infoByBonusName.heading ? <h3 className={b('content-heading')}>{infoByBonusName.heading}</h3> : null}

        <div className={b('content-text')}>{infoByBonusName.dangerousHtml(lang) ?? infoByBonusName.text}</div>
      </div>

      {/* <div className={b('content-text', { warning: true })}>{locale.wageringText}</div> */}

      <div className={b('back-button')} onClick={onInfoClick}>
        <Button>
          <span className={b('button-text')}>
            <ArrowIcon className={b('button-text-icon')} />
            {localeB.back}
          </span>
        </Button>
      </div>
    </div>
  )
}
